import { useState, useEffect } from 'react';

// True when the viewport is below `breakpoint` (default 768px). Re-renders
// only when the breakpoint is crossed, via a matchMedia 'change' listener, so
// v3 layouts can switch between the desktop grid and mobile cards without
// re-rendering on every resize event. Falls back to window.innerWidth where
// matchMedia is unavailable (jsdom, very old browsers).
export default function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    if (window.matchMedia) return window.matchMedia(query).matches;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (window.matchMedia) {
      const mql = window.matchMedia(query);
      const onChange = (e) => setIsMobile(e.matches);
      setIsMobile(mql.matches);
      // Safari < 14 only has the deprecated addListener/removeListener.
      if (mql.addEventListener) mql.addEventListener('change', onChange);
      else mql.addListener(onChange);
      return () => {
        if (mql.removeEventListener) {
          mql.removeEventListener('change', onChange);
        } else {
          mql.removeListener(onChange);
        }
      };
    }
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [query, breakpoint]);

  return isMobile;
}
